import { Store } from '@ngrx/store';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { UserContext } from 'app/core/store/session/user-context/user-context.interface';
import { AzureMonitoringService } from '../../core/services/AzureMonitoringService';
import * as fromRoot from '../../core/store/index';
import { Destroyable } from '../../core/util/destroyable';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';
import { ChangeDetectorRef, Directive, inject, OnDestroy } from '@angular/core';

let idCounter = 0;

@Directive()
export class BaseContainer extends Destroyable implements OnDestroy {
  protected id = 0;

  protected destroyed: boolean = false;

  authorization: AuthorizationMatrix;
  userContext: UserContext;
  protected store: Store<fromRoot.RootState> = inject(Store);
  protected azureMonitoringService = inject(AzureMonitoringService);
  protected cd = inject(ChangeDetectorRef);

  constructor() {
    super();
    this.id = ++idCounter; // eslint-disable-line
    this.logNavigation();
    this.store
      .pipe(
        map(state => state.session.authorization.data),
        distinctUntilChanged(),
        takeWhile(() => !this.destroyed)
      )
      .subscribe(authorization => (this.authorization = authorization));
    this.store
      .pipe(
        map(state => state.session.userContext),
        distinctUntilChanged(),
        takeWhile(() => !this.destroyed)
      )
      .subscribe(userContext => (this.userContext = userContext));
  }

  private logNavigation() {
    this.azureMonitoringService.logPageView(this.constructor?.name);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.destroyed = true;
  }
}
